const LinksConfig = {
    GITHUB_REPO: 'https://github.com/danilor/zen-ui'
}
export default LinksConfig;